import React, { useEffect, useState, useRef } from 'react';

import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import CsvDownloader from 'react-csv-downloader';
import { toast } from 'react-toastify';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBTooltip,
  MDBSpinner,
  MDBInput,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem
} from 'mdbreact';
import { isPast, getYear, format, set } from 'date-fns';
import NavBar from '../../components/NavBar';
import api from '../../services/api';
import { getData } from '../../services/auth';
import Paginacao from '../../components/Paginacao';
import { AddDenuncia } from './add/index';
import { Relatos } from './Relatos/index';
import { saveAs } from 'file-saver';
import { ModalRelatorioLeitura } from '../../components/Denuncias/PDF/modalLeitura';

export default function Denuncias() {
  const [abreModal, setAbreModal] = useState(false);
  const [abreRelato, setAbreRelato] = useState(null);
  const [denunciaSelecionada, setDenunciaSelecionada] = useState(null); // Denúncia para edição
  const [listaDenuncias, setListaDenuncias] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [currentUser, setCurrentUser] = useState(null); // Usuário atual
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);
  //modal relatorio de leitura
  const [abreModalRelatorio, setAbreModalRelatorio] = useState(false);
  const [PDFSelecionado, setPDFSelecionado] = useState(null);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const buscaDenuncias = async () => {
    setLoading(true);
    try {
      const params = { page: currentPage };
      if (search) {
        params.protocolo = search;
      }
      const result = await api.get('/dd-denuncia', { params });
      
      if (isMounted.current) {
        console.log(result.data);
        setListaDenuncias(result.data);
      }
    } catch (error) {
      if (isMounted.current) {
        toast.error('Erro ao carregar denúncias');
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    buscaDenuncias();
  }, [currentPage, search]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const addAbreModal = (bool, denuncia = null) => {
    if (isMounted.current) {
      setAbreModal(bool);
      setDenunciaSelecionada(denuncia);
    }
  };

  const abreModalRelato = (denuncia = null) => {
    if (isMounted.current) {
      setAbreRelato(denuncia);
    }
  };

  const abreModalLeitura = (bool, pdf = null) => {
    if (isMounted.current) {
      setAbreModalRelatorio(bool);
      setPDFSelecionado(pdf);
    }
  };

  const atualizaStatusNoModal = (denunciaId, novoStatus) => {
    if (isMounted.current) {
      setListaDenuncias((listaAntiga) => ({
        ...listaAntiga,
        rows: listaAntiga.rows.map((denuncia) =>
          denuncia.id === denunciaId
            ? { ...denuncia, dd_status: { status: novoStatus } }
            : denuncia
        ),
      }));

      if (abreRelato && abreRelato.id === denunciaId) {
        setAbreRelato((denunciaAtual) => ({
          ...denunciaAtual,
          dd_status: { status: novoStatus },
        }));
      }
    }
  };

  const excluirDenuncia = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta denúncia?')) {
      return;
    }
    setLoading(true);
    try {
      await api.delete(`/dd-denuncia/${id}`);
      if (isMounted.current) {
        toast.success('Denúncia excluída com sucesso');
        buscaDenuncias();
      }
    } catch (error) {
      if (isMounted.current) {
        toast.error(error.response?.data?.error || 'Erro ao excluir denúncia');
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    buscaDenuncias();
  }, [currentPage, search]);

  useEffect(() => {
    const userData = getData();
    if (userData) {
      setCurrentUser(userData);
    }
  }, []);

  const downloadFile = async (denunciaId, id, isRead = false) => {
    try {
      const response = await api.get(`/dd-denuncia/${id}/download`, {
        responseType: 'blob',
      });
      saveAs(response.data, 'denuncia.pdf');

      if (!isRead) {
        await api.post(`/dd-denuncia/${id}/pdf-leitura`);
        const responseDenuncia = await api.get(`/dd-denuncia/${denunciaId}`);
        const denunciaAtualizada = responseDenuncia.data;

        // Atualiza a lista substituindo a denúncia pelo id
        const updatedRows = listaDenuncias.rows.map((denuncia) =>
          denuncia.id === denunciaId ? denunciaAtualizada : denuncia
        );
        setListaDenuncias({ ...listaDenuncias, rows: updatedRows });
      }
    } catch (error) {
      console.error('Erro ao baixar PDF:', error);
      alert('Erro ao baixar o PDF. Tente novamente.');
    }
  };

  return (
    <NavBar>
      <MDBContainer>
        <h3 className="h3-responsive text-center font-weight-bolder">
          Disque Denúncia
        </h3>
        <MDBRow center className="d-flex justify-content-center align-items-center">
          <MDBCol>
            <MDBInput
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              outline
              className="bg-white"
              label="Insira o protocolo"
            />
          </MDBCol>
          <MDBCol>
            <MDBBtn onClick={buscaDenuncias} size="sm" color="grey">
              Filtrar
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <MDBContainer>
        <MDBRow between>
          <MDBCol className="h4-responsive font-weight-bolder">
            Lista de Denúncias
          </MDBCol>
          <MDBCol className="text-right">
            <MDBBtn onClick={() => addAbreModal(true)} color="green" size="sm">
              Criar Denúncia
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <MDBRow
          style={{ borderRadius: '5px' }}
          className="mx-3 px-3 d-none d-md-flex text-white font-weight-bolder grey darken-1"
        >
          <div className="col-12 col-md-3">Protocolo</div>
          <div className="col-12 col-md-2">Data Início</div>
          <div className="col-12 col-md-2">Classificação</div>
          <div className="col-12 col-md-2">Status</div>
          <div className="col-12 col-md-1">Sigilo</div>
          <div className="col-12 col-md-2 text-center">Ações</div>
        </MDBRow>
        {loading ? (
          <MDBSpinner />
        ) : (
          listaDenuncias?.rows?.map((denuncia) => (
            <MDBRow
              key={denuncia.id}
              style={{ borderRadius: '5px' }}
              className="p-3 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 bg-white"
            >
              <MDBCol
                size="12"
                md="3"
                className="d-flex justify-content-between font-weight-bolder"
              >
                {denuncia.protocolo}
              </MDBCol>
              <MDBCol
                size="12"
                md="2"
                className="d-flex justify-content-between"
              >
                <span className="d-sm-inline d-md-none mr-3">Data:</span>
                <span>
                  {format(new Date(denuncia.createdAt), 'dd/MM/yyyy HH:mm')}
                </span>
              </MDBCol>
              <MDBCol
                size="12"
                md="2"
                className="d-flex justify-content-between"
              >
                <span className="d-sm-inline d-md-none mr-3">Classificação:</span>
                <span>{denuncia.dd_classificacao.classificacao}</span>
              </MDBCol>
              <MDBCol
                size="12"
                md="2"
                className="d-flex justify-content-between"
              >
                <span className="d-sm-inline d-md-none mr-3">Status:</span>
                <span>{denuncia.dd_status.status}</span>
              </MDBCol>
              <MDBCol
                size="12"
                md="1"
                className="d-flex justify-content-between"
              >
                <span className="d-sm-inline d-md-none mr-3">Sigilo:</span>
                <span>{denuncia.dd_nivel_sigilo.nivel_sigilo}</span>
              </MDBCol>
              <MDBCol
                size="12"
                md="2"
                className="d-flex justify-content-center"
              >
                {denuncia.usuario_id === currentUser?.id && (
                  <MDBTooltip domElement tag="span" material placement="top">
                    <div
                      onClick={() => excluirDenuncia(denuncia.id)}
                      className="danger-text cursor-pointer mr-1"
                    >
                      <MDBIcon far icon="trash-alt" size="1x" />
                    </div>
                    <span className="font-weight-bolder">Excluir</span>
                  </MDBTooltip>
                )}
                {denuncia.usuario_id === currentUser?.id && (
                  <MDBTooltip domElement tag="span" material placement="top">
                    <div
                      onClick={() => addAbreModal(true, denuncia)}
                      className="primary-text cursor-pointer mr-1"
                    >
                      <MDBIcon far icon="edit" size="1x" />
                    </div>
                    <span className="font-weight-bolder">Editar</span>
                  </MDBTooltip>
                )}
                <MDBTooltip domElement tag="span" material placement="top">
                    <div
                      onClick={() => abreModalRelato(denuncia)}
                      className="primary-text cursor-pointer mr-1"
                    >
                      <MDBIcon far icon="eye" size="1x" />
                    </div>
                  <span className="font-weight-bolder">Ver Relatos</span>
                </MDBTooltip>
                
                {denuncia?.dd_denuncia_pdfs?.length > 0 &&
                  denuncia.dd_denuncia_pdfs.map((pdf) => {
                    // Verifica se o PDF foi lido pelo currentUser
                    const isRead = pdf.dd_denuncia_pdf_leituras?.some(
                      (leitura) => leitura.usuario_id === currentUser?.id
                    );
                    // Obtém a data de leitura (createdAt) se existir
                    const leitura = pdf.dd_denuncia_pdf_leituras?.find(
                      (leitura) => leitura.usuario_id === currentUser?.id
                    );
                    const createdAt = leitura ? new Date(leitura.createdAt).toLocaleString() : null;

                    return (
                      <MDBTooltip
                        key={pdf.id}
                        domElement
                        tag="span"
                        material
                        placement="top"
                      >
                        <div>
                          <MDBDropdown>
                            <MDBDropdownToggle tag="div"  style={{ cursor: 'pointer' }} className="primary-text cursor-pointer ml-1">
                              <MDBIcon far
                              icon="file-pdf"
                              size="1x"
                              style={{ color: isRead ? '' : 'green' }}
                              />
                            </MDBDropdownToggle>
                            <MDBDropdownMenu right>
                              <MDBDropdownItem onClick={() => downloadFile(denuncia.id, pdf.id, isRead)}>
                                <i className="fa fa-download mr-2"></i>
                                Download PDF
                              </MDBDropdownItem>
                              <MDBDropdownItem onClick={() => abreModalLeitura(true, pdf)}>
                                <MDBIcon far icon="file-alt" className="mr-2" />
                                Relatório de Leitura
                              </MDBDropdownItem>
                            </MDBDropdownMenu>
                          </MDBDropdown>
                        </div>
                        <span className="font-weight-bolder">
                          {isRead
                            ? `Download feito em ${createdAt}`
                            : 'Download PDF da Denúncia'}
                        </span>
                      </MDBTooltip>
                    );
                  })}
                
              </MDBCol>
            </MDBRow>
          ))
        )}
        <Paginacao
          page={currentPage}
          qtdTotal={listaDenuncias.count}
          onPageChange={handlePageChange}
        />
      </MDBContainer>
      <AddDenuncia
        openModal={abreModal}
        addAbreModal={addAbreModal}
        buscaDenuncias={buscaDenuncias}
        denuncia={denunciaSelecionada}
      />
      <Relatos
        openModal={abreRelato}
        abreModalRelato={abreModalRelato}
        atualizaStatusNoModal={atualizaStatusNoModal}
      />
      <ModalRelatorioLeitura
        modalLeitura={abreModalRelatorio}
        setModalLeitura={setAbreModalRelatorio}
        pdf={PDFSelecionado}
      />
    </NavBar>
  );
}